var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { mapGetters, mapActions } from 'vuex';
import Component from "vue-class-component";
import HeaderItem from "./components/HeaderItem.vue";
import DetailTable from "./components/DetailTable.vue";
import AccoutCheckService from "../../api/AccoutCheckService";
import EAccountStatus from "../../enum/EAccountStatus";
import EAccountType from '../../enum/EAccountType';
import { handle, EHanleType } from "../../biz/accountCheckBiz";
import GLOBAL_VUE from "../../globalVue";
import { toDetail } from '../../helper/util';
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
import { Loading } from "element-ui";
import { EBillType } from '../../enum/EBillType';
import OtherDetail from "../purchaseback/OtherDetail.vue";
import applicationDetail from '../applicationOrder/Detail.vue';
import InvoicePriview from "./components/uploaderInvoice.vue";
import SignDialog from "./components/SignDialog.vue";
import InvoiceInfoDialog from '../accountcheck/components/InvoiceInfoDialog.vue';
import AttachmentDialog from '../accountcheck/components/AttachmentDialog.vue';
import GenerateInvoice from "@/page/accountcheck/components/GenerateInvoice";
var detailDialogTemplate = "\n     <div class=\"table-header\" style=\"padding:10px;\" v-if=\"detail\">\n        <div class=\"f-tal\" v-if=\"detail.business_from_system==1\">\n                <span>\u5BF9\u8D26\u6298\u6263\u7387\uFF1A{{detail.discount_rate}}%</span>\n                <span style=\"margin-left: 30px;\">\n                  \u6298\u6263\u7387\u4F18\u60E0\u91D1\u989D\uFF1A\n                  <template v-if=\"isOpenMultiCurrency\">\n                    {{detail.default_currency_symbol_name}} {{detail.discount_rate_money}} / {{detail.currency_symbol_name}} {{detail.discount_rate_money_settlement_currency}}\n                  </template>\n                  <template v-else>\n                    {{detail.discount_rate_money}}\n                  </template>\n                </span>\n            </div>\n        <div class=\"t-row\" v-for=\"(item,index) in detail.discount\" :key=\"index\">\n            <div class=\"t-col col-2\">\n                <header-item :label=\"item.name\" con-span='1'>\n                  <template v-if=\"isOpenMultiCurrency\">\n                    {{detail.default_currency_symbol_name}} {{item.value}} / {{detail.currency_symbol_name}} {{item.value_rate}}\n                  </template>\n                  <template v-else>\n                    {{item.value}}\n                  </template>\n                </header-item>\n            </div>\n            <div class=\"t-col col-3\">\n                <header-item label=\"\u5907\u6CE8\">{{item.comment}}</header-item>\n            </div>\n        </div>\n    </div>\n";
var Detail = (function (_super) {
    __extends(Detail, _super);
    function Detail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = document.documentElement.clientHeight - 435;
        _this.swiperShow = false;
        _this.detail = {
            shop_list: [],
            order_list: [],
            other_order_items: [],
            invoice_items: [],
        };
        _this.handleType = EHanleType;
        _this.eType = EAccountType;
        _this.statusList = EAccountStatus;
        _this.total = 0;
        _this.start = 0;
        _this.limit = 20;
        _this.version = 0;
        _this.rejectReason = '';
        _this.rejectVisible = false;
        _this.status = "1";
        _this.isShowTip = false;
        _this.cancelOtherOrderListStr = '';
        _this.orderListProps = {};
        _this.otherOrderItemsProps = {};
        _this.invoiceItemsProps = {};
        return _this;
    }
    Detail.prototype.generateInvoice = function () {
        var _this = this;
        var instance = this.$dialog(GenerateInvoice, {
            data: {
                id: this.detail.order_id
            }
        }, {
            title: '发票开具',
            width: 440,
            height: 300,
            zIndex: 3000
        }).instance;
        instance.$on('openDocumentList', function () {
            _this.viewInvoice();
            _this.getDetail();
        });
        instance.$on('refresh', function () {
            _this.getDetail();
        });
        ;
        instance.$on('close', function () {
            console.log('close>>>');
            instance.$destroy();
        });
    };
    Detail.prototype.showPerDetail = function () {
        this.$dialog(this.detailDialog, {
            propsData: {
                isOpenMultiCurrency: this.isOpenMultiCurrency
            }
        }, {
            title: "折扣合计",
            width: 700,
            height: 350
        });
    };
    Detail.prototype.toLookImg = function (row) {
        var _this = this;
        this.service.getOrderDocumentList({ order_id: row.order_id })
            .then(function (res) {
            var data = res.data;
            if (data.success && data.data.length) {
                if (data.data.length) {
                    var order_document = Array.isArray(data.data) ? data.data : [];
                    var instance = _this.$dialog(InvoicePriview, {
                        data: {
                            document_pic: order_document,
                            order_id: row.order_id
                        }
                    }, {
                        title: "单据图片",
                        width: 810,
                        height: 620
                    }).instance;
                    instance.$on("editClient:ok", function () {
                        _this.$emit('search');
                    });
                }
            }
        }, function (err) { });
    };
    Detail.prototype.pageChange = function (pager) {
        this.start = pager.start;
        this.limit = pager.limit;
        this.getDetail();
    };
    Detail.prototype.getList = function () {
        GLOBAL_VUE.$emit("closeTab", this);
        if (this.opener) {
            this.opener.getList();
        }
    };
    Detail.prototype.handle = function (type) {
        var _this = this;
        console.log(type);
        if (type == 2) {
            this.$confirm("是否要确认", "提示", {}).then(function (res) {
                var loadingInstance = Loading.service({ fullscreen: true });
                _this.service.confirm({ order_id: _this.detail.order_id }).then(function (res) {
                    loadingInstance.close();
                    var _a = res.data, code = _a.code, data = _a.data;
                    if (res.data.code == 72) {
                        var instance = _this.$dialog(SignDialog, {
                            data: {
                                miniprogramQrcode: data && data.msg_data && data.msg_data.url || '',
                                selectRows: [_this.detail]
                            }
                        }, {
                            title: "签字",
                            width: 640,
                            height: 420,
                            zIndex: 1002,
                        }).instance;
                        instance.$on("submitSuccess", function (res) {
                            _this.getDetail();
                        });
                        _this.signInstance = instance;
                    }
                    else if (res.data.code == 76) {
                        _this.$message.error(res.data.msg);
                        _this.getDetail();
                    }
                    else {
                        _this.$message.success('操作成功');
                        _this.getDetail();
                    }
                }).catch(function (err) {
                    loadingInstance.close();
                    _this.$message.error(err.message || err.msg);
                });
            }, function () { });
            return;
        }
        handle(type, this, this.detail.order_id);
    };
    Detail.prototype.getDetail = function () {
        var _this = this;
        var data_type;
        if (this.status === '3') {
            data_type = 3;
        }
        else {
            if (this.status === '1') {
                if (this.detail.statement_model === 1) {
                    data_type = 1;
                }
                else if (this.detail.statement_model === 2) {
                    data_type = 2;
                }
                else {
                    data_type = 1;
                }
            }
            else {
                if (this.detail.statement_model !== 1) {
                    data_type = 1;
                }
                else {
                    data_type = 2;
                }
            }
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.rowId,
            start: this.start,
            limit: this.limit,
            data_type: data_type,
        };
        this.service.getDetail(params).then(function (res) {
            loadingInstance.close();
            _this.detail = res.data.data;
            _this.version = res.data.business_config_res && res.data.business_config_res.business_version;
            if (_this.detail.from_system !== 1) {
                _this.orderListProps = {
                    'order_document_money': true,
                    'order_document_tax_money': true,
                    'un_order_document_money': true,
                    'invoice_no_items': true
                };
                _this.otherOrderItemsProps = {
                    'order_document_money': true,
                    'order_document_tax_money': true,
                    'un_order_document_money': true,
                    'invoice_no_items': true
                },
                    _this.invoiceItemsProps = {};
            }
            else {
                _this.orderListProps = {
                    'invoice_no_items': true
                };
                _this.otherOrderItemsProps = {
                    'invoice_no_items': true
                };
                _this.invoiceItemsProps = {
                    'order_document_money': true,
                    'order_document_tax_money': true,
                    'un_order_document_money': true,
                    'invoice_no_items': true
                };
            }
            var cancelOtherOrderList = [];
            res.data.data.cancel_other_list.forEach(function (item) {
                cancelOtherOrderList.push(item.other_order_code);
            });
            cancelOtherOrderList = Array.from(new Set(cancelOtherOrderList));
            _this.cancelOtherOrderListStr = cancelOtherOrderList.join('、');
            _this.isShowTip = res.data.data.cancel_other_list.length > 0;
            _this.detailDialog = Vue.extend({
                template: detailDialogTemplate,
                props: {
                    isOpenMultiCurrency: {
                        type: Boolean,
                        default: false
                    }
                },
                data: function () { return ({
                    detail: _this.detail
                }); },
                components: {
                    HeaderItem: HeaderItem
                }
            });
            _this.total = res.data.data.total || 0;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    Detail.prototype.mounted = function () {
        if (!this.rowId) {
            return;
        }
        ;
        this.getDetail();
    };
    Detail.prototype.created = function () {
        var _this = this;
        this.service = AccoutCheckService.getInstance();
        GLOBAL_VUE.$on('so_sign:ok', function () {
            _this.$message.success('签字成功');
            _this.signInstance && _this.signInstance.$closeDialog && _this.signInstance.$closeDialog();
            _this.getDetail();
        });
    };
    Detail.prototype.addTab = function (options) {
        options.opener = this;
        GLOBAL_VUE.$emit('addTab', options);
    };
    Detail.prototype.toDetail = function (row) {
        if (this.detail.business_type == 1) {
            switch (row.order_type) {
                case 1:
                    toDetail(EBillType.PurIn, row.order_id, this);
                    break;
                case 2:
                    this.addTab({
                        component: OtherDetail,
                        title: '退货单详情',
                        showExist: true,
                        opener: this,
                        name: 'purchaseback_detail' + row.order_id,
                        cprops: {
                            rowId: row.order_id
                        }
                    });
                    window._czc.push(["_trackEvent", '退货单', '退货单详情']);
                    break;
            }
        }
        else if (this.detail.business_type == 2) {
            var order_id = row.order_id;
            switch (row.order_type) {
                case 2:
                    toDetail(EBillType.PurBack, row.order_id, this);
                    break;
                case 4:
                    toDetail(EBillType.Deliver, row.order_id, this);
                    break;
                case 5:
                    toDetail(EBillType.ShopAfterSales, row.order_id, this);
                    break;
                case 6:
                    this.addTab({
                        component: applicationDetail,
                        title: '查看费用',
                        showExist: true,
                        name: 'application_order_' + row.order_type,
                        cprops: {
                            order_id: order_id,
                        },
                    });
                    window._czc.push(['_trackEvent', '费用管理', '查看费用']);
            }
        }
    };
    Detail.prototype.reject = function () {
        this.rejectVisible = true;
    };
    Detail.prototype.cancelReject = function () {
        this.rejectVisible = false;
        this.rejectReason = '';
    };
    Detail.prototype.submitReject = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.rejectStatementOrder({
            order_ids: this.detail.order_id,
            reject_reason: this.rejectReason
        }).then(function (res) {
            loadingInstance.close();
            if (res.data && res.data.success) {
                _this.$message.success(res.data.msg || '驳回成功');
                _this.rejectVisible = false;
                _this.rejectReason = '';
                _this.getDetail();
                window._czc.push(["_trackEvent", '客户对账单驳回', '客户对账单驳回']);
            }
            else {
                _this.$message.error(res.data.msg || '驳回失败');
            }
            _this.getDetail();
        }, function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    Detail.prototype.viewInvoice = function () {
        var _this = this;
        var instance = this.$dialog(InvoiceInfoDialog, {
            data: {
                invoice_info: this.detail.invoice_info || {},
                invoice_status: this.detail.invoice_status || 0,
                detail: this.detail,
                token: this.user.token,
                order_status_name: this.detail.order_status_name,
                type: 'edit',
                getAuth: this.getAuth,
                parentPageAuth: this.Root_PageAuth
            }
        }, {
            title: "发票信息",
            width: 640,
            height: 560,
            zIndex: 1002,
        }).instance;
        instance.$on("submitSuccess", function (res) {
            _this.getDetail();
        });
    };
    Detail.prototype.viewAttachment = function () {
        var _this = this;
        var instance = this.$dialog(AttachmentDialog, {
            data: {
                detail: this.detail,
                token: this.user.token,
                order_status_name: this.detail.order_status_name,
                type: 'edit',
                getAuth: this.getAuth,
                parentPageAuth: this.Root_PageAuth
            }
        }, {
            title: "附件信息",
            width: 640,
            height: 560,
            zIndex: 1002,
        }).instance;
        instance.$on("submitSuccess", function (res) {
            _this.getDetail();
        });
    };
    Detail.prototype.handleCloseTip = function () {
        this.isShowTip = false;
    };
    Detail.prototype.tabClick = function (tab) {
        this.start = 0;
        this.getDetail();
    };
    Detail = __decorate([
        auth(nameDict["客户对账单"]),
        Component({
            methods: __assign({}, mapActions(["getAuth"])),
            components: {
                HeaderItem: HeaderItem,
                DetailTable: DetailTable
            },
            computed: __assign({ isShowPrePayment: function () {
                    return this.version >= 3230501;
                },
                isOpenMultiCurrency: function () {
                    return this.$store.getters.getBusinessConfig && this.business_id
                        ? this.$store.getters.getBusinessConfig(Number(this.business_id), 'is_open_multi_currency', 0) == 1
                        : false;
                } }, mapGetters({
                "user": "user"
            }))
        })
    ], Detail);
    return Detail;
}(Vue));
export default Detail;
